<template>
  <section class="bg-[#0F0F0F] py-16 px-4 md:px-20 text-white">
    <div class="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
      <!-- Sol: Metin -->
      <div class="text-left">
        <h2 class="text-3xl md:text-4xl font-light mb-6">
          <span class="font-bold text-white">
            <span class="text-[#666]">MEM22 Akademi</span>
          </span>
          {{ t("academy.what_is") }}
        </h2>

        <p class="text-base text-gray-400 leading-relaxed mb-4">
          {{ t("academy.description_1") }}
        </p>

        <p class="text-base text-gray-400 leading-relaxed mb-4">
          {{ t("academy.description_2") }}
        </p>

        <p class="text-base text-gray-400 leading-relaxed mb-8">
          {{ t("academy.description_3") }}
        </p>

        <NuxtLink
          to="/contact"
          class="inline-block bg-white text-black px-6 py-3 rounded-lg font-semibold hover:bg-gray-200 transition"
        >
          {{ t("academy.join_now") }}
        </NuxtLink>
      </div>

      <!-- Sağ: YouTube Video -->
      <div class="w-full">
        <div class="rounded-lg overflow-hidden shadow-2xl">
          <iframe
            class="w-full min-h-[450px] lg:min-h-[360px] xl:min-h-[420px]"
            src="https://www.youtube.com/embed/RuufHyPW1XE?si=jYUdZfCDDkb8tpt4"
            loading="lazy"
            title="YouTube video"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from "#imports";

const { t } = useI18n();
defineOptions({ name: "AcademyVideo" });
</script>
